import { IconDefinition } from "./types";

const circleQuestion: IconDefinition = {
  iconName: "circle-question",
  width: 512,
  height: 512,
  svgPathData:
    "M464 256a208 208 0 1 0 -416 0 208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-80c-17.7 0-32 14.3-32 32l-48 0c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.1-20.5 57.5-38.2 70-6.3 4.4-12.5 7.8-17.8 10.4l0 21.9-48 0 0-56.7c1.4-.4 2.7-.7 4.1-1.1 12.2-3.2 23.3-6.1 34.1-13.7 10.4-7.3 17.8-16.9 17.8-30.8 0-17.7-14.3-32-32-32zM232 344l48 0 0 48-48 0 0-48z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "circle-question",
  unicode: 0xf059,
};

export { circleQuestion };
